/* OS WDCT Consumer PDP - interactions
   Day 1 2026-05-17. Scoped to .pdp--wdct sections.
   Behaviors: variant swap (color+size), gallery thumb click, FAQ accordion, video click-to-play.
*/
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var v = (cents / 100);
    if (Math.floor(v) === v) return '$' + v.toLocaleString('en-US');
    return '$' + v.toFixed(2);
  }

  /* ---------- Variant switcher ---------- */
  function initVariantSwitcher() {
    var form = document.querySelector('[data-wdct-form]');
    if (!form) return;
    var dataNode = document.querySelector('[data-wdct-variants]');
    if (!dataNode) return;
    var variants;
    try { variants = JSON.parse(dataNode.textContent); } catch (e) { return; }

    var pdp = document.querySelector('.pdp--wdct');
    if (!pdp) return;

    var state = { color: null, size: null };

    // Init from current active swatch + pill
    var activeSwatch = pdp.querySelector('.wdct-swatch.is-active');
    var activeSize = pdp.querySelector('.wdct-size-pill.is-active');
    if (activeSwatch) state.color = activeSwatch.dataset.wdctColorValue;
    if (activeSize) state.size = activeSize.dataset.wdctSizeValue;

    function findVariant() {
      return variants.find(function (v) {
        var opts = v.options || [];
        return opts.indexOf(state.color) !== -1 && opts.indexOf(state.size) !== -1;
      });
    }

    function setActiveButton(group, btn) {
      $$(group, pdp).forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
      });
    }

    function updateUI() {
      var v = findVariant();
      if (!v) {
        // No variant for this colour + size (e.g. Mahogany / Large 27.5x58). Never leave the previous
        // variant id in the form: that adds the wrong item to the cart.
        var input0 = pdp.querySelector('[data-wdct-variant-input]');
        if (input0) input0.value = '';
        var atc0 = pdp.querySelector('[data-wdct-atc]');
        var atcLabel0 = pdp.querySelector('[data-wdct-atc-label]');
        var atcTotal0 = pdp.querySelector('[data-wdct-atc-total]');
        if (atc0) { atc0.disabled = true; atc0.setAttribute('aria-disabled', 'true'); }
        if (atcLabel0) atcLabel0.textContent = 'Not available in this color';
        if (atcTotal0) atcTotal0.textContent = '';
        var colorLabel0 = pdp.querySelector('[data-wdct-color-label]');
        var sizeLabel0 = pdp.querySelector('[data-wdct-size-label]');
        if (colorLabel0) colorLabel0.textContent = '\u00b7 ' + state.color;
        if (sizeLabel0) sizeLabel0.textContent = '\u00b7 ' + state.size;
        refreshOptionState();
        return;
      }
      var input = pdp.querySelector('[data-wdct-variant-input]');
      if (input) input.value = v.id;

      var priceEl = pdp.querySelector('[data-wdct-price]');
      if (priceEl) priceEl.textContent = formatMoney(v.price);

      var listEl = pdp.querySelector('[data-wdct-list-price]');
      var saveEl = pdp.querySelector('[data-wdct-save]');
      var savePct = pdp.querySelector('[data-wdct-save-pct]');
      if (v.compare_at_price && v.compare_at_price > v.price) {
        if (listEl) { listEl.textContent = formatMoney(v.compare_at_price); listEl.hidden = false; }
        if (saveEl) saveEl.hidden = false;
        if (savePct) savePct.textContent = Math.round((1 - v.price / v.compare_at_price) * 100);
      } else {
        if (listEl) listEl.hidden = true;
        if (saveEl) saveEl.hidden = true;
      }

      var atc = pdp.querySelector('[data-wdct-atc]');
      var atcLabel = pdp.querySelector('[data-wdct-atc-label]');
      var atcTotal = pdp.querySelector('[data-wdct-atc-total]');
      if (atc) {
        if (v.available) {
          atc.disabled = false;
          atc.removeAttribute('aria-disabled');
          if (atcLabel) atcLabel.textContent = 'Add to cart';
          if (atcTotal) atcTotal.textContent = '· ' + formatMoney(v.price);
        } else {
          atc.disabled = true;
          atc.setAttribute('aria-disabled', 'true');
          if (atcLabel) atcLabel.textContent = 'Sold out';
          if (atcTotal) atcTotal.textContent = '';
        }
      }

      var colorLabel = pdp.querySelector('[data-wdct-color-label]');
      var sizeLabel = pdp.querySelector('[data-wdct-size-label]');
      if (colorLabel) colorLabel.textContent = '· ' + state.color;
      if (sizeLabel) sizeLabel.textContent = '· ' + state.size;

      // R7-3: sync gallery hero to current variant's featured image (1 of 24 variants unbound; falls through gracefully).
      var heroImg = pdp.querySelector('[data-wdct-hero-img]');
      if (heroImg && v.featured_image && v.featured_image.src) {
        var base = v.featured_image.src;
        heroImg.src = base + (base.indexOf('?') === -1 ? '?width=1280' : '&width=1280');
        heroImg.srcset = base + (base.indexOf('?') === -1 ? '?width=640 640w, ' : '&width=640 640w, ')
                       + base + (base.indexOf('?') === -1 ? '?width=960 960w, ' : '&width=960 960w, ')
                       + base + (base.indexOf('?') === -1 ? '?width=1280 1280w' : '&width=1280 1280w');
        if (v.featured_image.alt) heroImg.alt = v.featured_image.alt;
      }

      refreshOptionState();
    }

    // 2026-09-13 (Wide 27.5x58): a colour can now lack a size (Mahogany has no Large 27.5x58). Refresh swatch/pill
    // state from a helper so the no-variant path below can call it too.
    function refreshOptionState() {
      // Mark swatches sold-out-in-current-size
      $$('.wdct-swatch', pdp).forEach(function (sw) {
        var color = sw.dataset.wdctColorValue;
        var match = variants.find(function (vv) {
          var opts = vv.options || [];
          return opts.indexOf(color) !== -1 && opts.indexOf(state.size) !== -1;
        });
        sw.setAttribute('data-soldout', (!match || !match.available) ? 'true' : 'false'); // no variant for this colour+size counts as sold out (matches the Liquid initial render)
      });

      // Re-render size pill prices/sold-out tags for the current color
      $$('.wdct-size-pill', pdp).forEach(function (pill) {
        var sizeVal = pill.dataset.wdctSizeValue;
        var match = variants.find(function (vv) {
          var opts = vv.options || [];
          return opts.indexOf(state.color) !== -1 && opts.indexOf(sizeVal) !== -1;
        });
        var priceEl2 = pill.querySelector('.wdct-size-price');
        var soTag = pill.querySelector('.wdct-soldout-tag');
        if (match && priceEl2) {
          var html = formatMoney(match.price);
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html += '<span class="wdct-size-price-list">' + formatMoney(match.compare_at_price) + '</span>';
          }
          priceEl2.innerHTML = html;
        }
        if (!match && priceEl2) priceEl2.innerHTML = '';
        if (!match || !match.available) {
          if (!soTag) {
            var s = document.createElement('span');
            s.className = 'wdct-soldout-tag';
            s.textContent = 'Sold out';
            pill.insertBefore(s, pill.firstChild);
          }
        } else if (soTag) {
          soTag.remove();
        }
      });
    }

    $$('.wdct-swatch', pdp).forEach(function (sw) {
      sw.addEventListener('click', function () {
        state.color = sw.dataset.wdctColorValue;
        setActiveButton('.wdct-swatch', sw);
        updateUI();
      });
    });
    $$('.wdct-size-pill', pdp).forEach(function (pill) {
      pill.addEventListener('click', function () {
        state.size = pill.dataset.wdctSizeValue;
        setActiveButton('.wdct-size-pill', pill);
        updateUI();
      });
    });

    // Quantity stepper
    var qtyInput = pdp.querySelector('[data-wdct-qty-input]');
    var qtyDec = pdp.querySelector('[data-wdct-qty-dec]');
    var qtyInc = pdp.querySelector('[data-wdct-qty-inc]');
    if (qtyDec && qtyInput) qtyDec.addEventListener('click', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1); });
    if (qtyInc && qtyInput) qtyInc.addEventListener('click', function () { qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1; });

    updateUI();
  }

  /* ---------- Gallery thumbs ---------- */
  function initGallery() {
    var pdp = document.querySelector('.pdp--wdct');
    if (!pdp) return;
    var heroImg = pdp.querySelector('[data-wdct-hero-img]');
    var counter = pdp.querySelector('[data-wdct-counter]');
    var thumbs = $$('[data-wdct-thumb]', pdp);
    var total = thumbs.length;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (heroImg) {
          heroImg.src = thumb.dataset.wdctSrc;
          heroImg.srcset = thumb.dataset.wdctSrcset;
          heroImg.alt = thumb.dataset.wdctAlt || '';
        }
        if (counter) counter.textContent = (parseInt(thumb.dataset.wdctIndex, 10) + 1) + ' / ' + total;
      });
    });

    // Touch swipe on the hero advances prev/next (John's 2026-06-10 on-device report:
    // image could only be changed via the thumbs below). Routes through thumb.click()
    // so counter + active state stay in sync. Listeners are passive and never
    // preventDefault: vertical page scroll and pinch-zoom (multi-touch bails) keep
    // native behavior. Horizontal-dominant threshold avoids firing on diagonal scrolls.
    var hero = pdp.querySelector('[data-wdct-hero]');
    if (hero && total > 1) {
      var swipeStartX = 0, swipeStartY = 0, swipeTracking = false;
      hero.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { swipeTracking = false; return; }
        swipeTracking = true;
        swipeStartX = e.touches[0].clientX;
        swipeStartY = e.touches[0].clientY;
      }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (!swipeTracking || e.touches.length > 0) return;
        swipeTracking = false;
        var t = e.changedTouches[0];
        if (!t) return;
        var dx = t.clientX - swipeStartX;
        var dy = t.clientY - swipeStartY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        var active = pdp.querySelector('[data-wdct-thumb].is-active');
        var idx = active ? parseInt(active.dataset.wdctIndex, 10) : 0;
        if (isNaN(idx)) idx = 0;
        var next = dx < 0 ? idx + 1 : idx - 1; // swipe left = next image
        if (next < 0) next = total - 1;
        if (next >= total) next = 0;
        if (thumbs[next]) thumbs[next].click();
      }, { passive: true });
      hero.addEventListener('touchcancel', function () { swipeTracking = false; }, { passive: true });
    }
  }

  /* ---------- FAQ accordion ---------- */
  function initFAQ() {
    $$('[data-wdct-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.wdct-faq__item');
        if (!item) return;
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      });
    });
  }

  /* ---------- Video click-to-play ---------- */
  function initVideo() {
    $$('[data-wdct-video]').forEach(function (box) {
      var src = box.dataset.wdctVideoSrc;
      if (!src) return;
      function play() {
        if (box.querySelector('video')) return;
        var v = document.createElement('video');
        v.src = src;
        v.controls = true;
        v.autoplay = true;
        v.className = 'wdct-video__player';
        v.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;background:#000;object-fit:cover;';
        box.appendChild(v);
        var play = box.querySelector('.wdct-video__play');
        var label = box.querySelector('.wdct-video__label');
        var thumb = box.querySelector('.wdct-video__thumb');
        if (play) play.style.display = 'none';
        if (label) label.style.display = 'none';
        if (thumb) thumb.style.display = 'none';
      }
      box.addEventListener('click', play);
      box.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(); }
      });
    });
  }

  /* ---------- Sticky desktop ATC (B1 backlog) ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-wdct-sticky-atc]');
    var sentinel = document.querySelector('.wdct-buybox__cart-row');
    if (!bar || !sentinel) return;

    // Hide on mobile via CSS; observer still runs but bar is display:none
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // Show sticky bar when in-flow cart row is NOT intersecting (scrolled past)
        // AND we've scrolled some distance (avoid showing on initial load before user scrolls)
        if (!e.isIntersecting && window.scrollY > 100) {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        } else {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        }
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
    observer.observe(sentinel);

    // Wire sticky button to submit main product form
    var btn = bar.querySelector('[data-wdct-sticky-atc-btn]');
    var form = document.querySelector('[data-wdct-form]');
    if (btn && form) {
      btn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    // Sync sticky price + meta + thumb image with variant switcher updates.
    var pdp = document.querySelector('.pdp--wdct');
    if (!pdp) return;
    var priceEl = bar.querySelector('[data-wdct-sticky-price]');
    var metaEl = bar.querySelector('[data-wdct-sticky-meta]');
    var thumbEl = bar.querySelector('[data-wdct-sticky-thumb]'); // R10: sticky thumb image
    var mainPrice = pdp.querySelector('[data-wdct-price]');
    var colorLabel = pdp.querySelector('[data-wdct-color-label]');
    var sizeLabel = pdp.querySelector('[data-wdct-size-label]');
    var heroImg = pdp.querySelector('[data-wdct-hero-img]');

    var syncBar = function () {
      if (priceEl && mainPrice) priceEl.textContent = mainPrice.textContent;
      if (metaEl && colorLabel && sizeLabel) {
        var c = (colorLabel.textContent || '').replace(/^[·\s]+/, '').trim();
        var s = (sizeLabel.textContent || '').replace(/^[·\s]+/, '').trim();
        metaEl.textContent = c + ' · ' + s;
      }
      // R10: mirror the hero image to the sticky thumb on every variant change.
      if (thumbEl && heroImg && heroImg.src) {
        // Rebuild a 120w url from the hero src so the sticky thumb stays sharp at 56px CSS.
        var src = heroImg.src;
        var sep = src.indexOf('?') === -1 ? '?' : '&';
        // Strip any existing width param then re-append for 120.
        var clean = src.replace(/[?&]width=\d+/, '');
        var sep2 = clean.indexOf('?') === -1 ? '?' : '&';
        thumbEl.src = clean + sep2 + 'width=120';
      }
    };
    var mo = new MutationObserver(syncBar);
    if (mainPrice) mo.observe(mainPrice, { childList: true, characterData: true, subtree: true });
    if (colorLabel) mo.observe(colorLabel, { childList: true, characterData: true, subtree: true });
    if (sizeLabel) mo.observe(sizeLabel, { childList: true, characterData: true, subtree: true });
    if (heroImg) mo.observe(heroImg, { attributes: true, attributeFilter: ['src'] });
    syncBar();
  }

  /* ---------- Live Trustify aggregate JS hook (B5 backlog) ---------- */
  function initTrustifyAggregate() {
    var avgEl = document.querySelector('[data-wdct-rating-avg]');
    var countEl = document.querySelector('[data-wdct-rating-count]');
    if (!avgEl || !countEl) return;

    var tries = 0;
    var maxTries = 25; // 25 x 200ms = 5s window
    var interval = setInterval(function () {
      tries++;
      var stat = window.trReviewsProduct && window.trReviewsProduct.reviews_statistic;
      if (stat && typeof stat.rating_avg === 'number') {
        avgEl.textContent = stat.rating_avg.toFixed(1);
        if (typeof stat.total_rating === 'number') {
          countEl.textContent = stat.total_rating;
        }
        clearInterval(interval);
        return;
      }
      if (tries >= maxTries) {
        clearInterval(interval);
        // Fail silently. Hardcoded Liquid fallback values stay visible.
      }
    }, 200);
  }

  /* ---------- Photo wall (R8): horizontal scroll-snap carousel + "View all reviews" tile ---------- */
  function initPhotoWall() {
    var wall = document.querySelector('[data-wdct-photo-wall]');
    if (!wall) return;
    var tries = 0;
    var maxTries = 40;
    var interval = setInterval(function () {
      tries++;
      var data = window.trReviewsProduct;
      var pinned = data && Array.isArray(data.reviews_pin_photo) ? data.reviews_pin_photo : null;
      if (!pinned) {
        if (tries >= maxTries) clearInterval(interval);
        return;
      }
      clearInterval(interval);
      var photos = [];
      pinned.forEach(function (r) {
        if (Array.isArray(r.images)) {
          r.images.forEach(function (im) {
            var url = im && (im.image_url || im.image);
            if (url) photos.push({ url: url, thumb: im.thumbnail_url || url, alt: r.reviewer_name || '' });
          });
        }
      });
      // Pull additional photos from regular reviews (de-duplicate by URL).
      var seen = {};
      photos.forEach(function (p) { seen[p.url] = true; });
      (data.reviews || []).forEach(function (r) {
        if (Array.isArray(r.images)) {
          r.images.forEach(function (im) {
            var url = im && (im.image_url || im.image);
            if (url && !seen[url]) {
              seen[url] = true;
              photos.push({ url: url, thumb: im.thumbnail_url || url, alt: r.reviewer_name || '' });
            }
          });
        }
      });
      if (photos.length === 0) return; // keep server-side fallback visible
      // XSS-safe DOM construction (2026-06-10 audit 2.4): reviewer names and image URLs
      // are Trustify-supplied strings; never concatenate them into innerHTML. Same
      // textContent/attribute pattern as the popcard.
      wall.textContent = '';
      photos.forEach(function (p) {
        var tile = document.createElement('div');
        tile.className = 'wdct-photo';
        var img = document.createElement('img');
        img.src = p.thumb;
        img.alt = 'Customer photo by ' + p.alt;
        img.loading = 'lazy';
        tile.appendChild(img);
        wall.appendChild(tile);
      });
      // Always-on "View all reviews" tile at the end of the carousel. Scrolls to the reviews section.
      var more = document.createElement('a');
      more.className = 'wdct-photo wdct-photo--more';
      more.href = '#wdct-reviews';
      more.setAttribute('data-wdct-view-all', '');
      var moreInner = document.createElement('div');
      var moreNum = document.createElement('div');
      moreNum.className = 'wdct-photo__num';
      moreNum.textContent = 'View all';
      var moreLbl = document.createElement('div');
      moreLbl.className = 'wdct-photo__lbl';
      moreLbl.textContent = (data.reviews_statistic && data.reviews_statistic.total_rating ? data.reviews_statistic.total_rating + ' reviews \u2192' : 'reviews \u2192');
      moreInner.appendChild(moreNum);
      moreInner.appendChild(moreLbl);
      more.appendChild(moreInner);
      wall.appendChild(more);
      // Smooth-scroll the view-all link to the reviews mount.
      var viewAll = wall.querySelector('[data-wdct-view-all]');
      if (viewAll) {
        viewAll.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.querySelector('#wdct-reviews, .wdct-reviews-mount, trustify-review-box');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
      // R10: continuous slow scroll (~30 px/sec) via requestAnimationFrame. Replaces R9 step-then-wait pattern - owner wanted constant motion, not tick-pause-tick.
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;
      // R11: slower scroll via float accumulator. scrollLeft snaps to integer on flex containers, so a raw `+= 0.3` truncates and never advances. Accumulate a float, advance scrollLeft only when accum crosses a whole-pixel boundary. Net ~18 px/sec at 60fps.
      var pxPerFrame = 0.3;
      var accum = 0;
      var paused = false;
      var userScrollLockUntil = 0;
      wall.addEventListener('mouseenter', function () { paused = true; });
      wall.addEventListener('mouseleave', function () { paused = false; });
      wall.addEventListener('focusin', function () { paused = true; });
      wall.addEventListener('focusout', function () { paused = false; });
      wall.addEventListener('wheel', function () { userScrollLockUntil = Date.now() + 5000; }, { passive: true });
      wall.addEventListener('touchstart', function () { userScrollLockUntil = Date.now() + 5000; }, { passive: true });
      function tick() {
        if (!paused && Date.now() >= userScrollLockUntil) {
          accum += pxPerFrame;
          if (accum >= 1) {
            var delta = Math.floor(accum);
            accum -= delta;
            var maxScroll = wall.scrollWidth - wall.clientWidth;
            var next = wall.scrollLeft + delta;
            if (next >= maxScroll - 1) {
              wall.scrollLeft = 0;
              accum = 0;
            } else {
              wall.scrollLeft = next;
            }
          }
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }, 200);
  }

  function init() {
    initVariantSwitcher();
    initGallery();
    initFAQ();
    initVideo();
    initStickyAtc();
    initTrustifyAggregate();
    initPhotoWall();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
